module.exports = __webpack_public_path__ + "static/img/作品51.d6ff732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品51.png
// module id = 4/BV
// module chunks = 1